import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import SurplusResourcesMaintenance41_2bTable from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const SurplusResourcesMaintenance41_2b = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("SURPLUS_RESOURCES_MAINTENANCE") || "Surplus resources"}
        subDescription={t("SURPLUS_RESOURCES_MAINTENANCE_41_2B_DESC") || "Fill in information about surplus resources from maintenance processes."}
        isNormal={true}
        number={"41.2b"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`surplus-resources-maintenance-41-2b-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <SurplusResourcesMaintenance41_2bTable productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default SurplusResourcesMaintenance41_2b;

